import styled from "styled-components";

import Text from "@/components/Text";
import HomeAccordion from "./HomeAccordion";
import { HomeContainer } from "../index";

const Heading = styled(Text)`
  margin-bottom: 64px;
`;

const Section = styled.section`
  padding: 204px 0 96px;
`;

const HomeFaq = () => {
  return (
    <Section>
      <HomeContainer>
        <Heading as="h1" $type="heading1">
          Privacy Policy
        </Heading>
        <HomeAccordion
          title={
            "1. What personal information do we collect and why do we collect it?"
          }
        >
          <Text>
            1.1. Information you provide to us: When you register for an account
            on our site, we ask for your email address so we can check whether
            you already have an account, if you don't, we ask you to provide:
            <br />
            <strong>— Password</strong> - oh, don't worry, we don't see it, so
            feel free to use the name of your crush (as long as it's at least 8
            symbols and has a number in it:) ). You can always reset it too, in
            case it doesn't work out.
            <br />
            <strong>— Full name</strong> - you can lie here, nobody will know.
            We use this as your Pen name when you comment or post articles. Feel
            free to use a tool like{" "}
            <a
              href="https://www.name-generator.org.uk/pen-name/"
              rel="nofollow"
            >
              this
            </a>{" "}
            if you please. You can change it once the popularity becomes too
            heavy or any other time, we're chill.
            <br />
            We will also ask you if you would like to receive our awesome
            newsletter, no pressure, and then we will send you an activation
            email - just to make sure you're a real person or at least a very
            clever bot. Ah, true, almost forgot, if you chose to use your
            Facebook login to create an account with us, you give Facebook
            permission to share with us the associated email and your profile
            name, good news though, that also means we don't need to vet you for
            humanness, so no confirmation email - woohoo!
          </Text>
          <Text>
            1.2. Information we get from your device: In order to make sure that
            the site performs at its best - functions properly, is informative,
            up-to date and tailored just for you - when you visit it, we collect
            information from your device. That may include:
            <br />
            <strong>— Device info</strong> - we want to know if you should be
            seeing a desktop or mobile version of the site, which application
            store you might need and such.
            <br />
            <strong>— Network data</strong> - such as IP, helps us diagnose
            problems with our servers, administer our sites and also helps us to
            make sure our comment section is hate free.
            <br />
            <strong>— Cookies </strong> - the no calories kind. There is more
            detailed info about them below, but in short, they let us know how
            you use our site and optimize it for a better user experience.
          </Text>
          <Text>
            1.3. Share functions: When you share our articles with friends, you
            do so using social widgets and according to those social networks
            policies.
          </Text>
        </HomeAccordion>
        <HomeAccordion title={"2. How the information is used?"}>
          <Text>
            2.1. We are relying on several separate bases to process your
            information as required by law. In order to provide our service to
            you, we process some data with <strong>Legitimate Interest</strong>{" "}
            in mind:
            <br />
            2.1.1. When the purpose is to deliver the <strong>service:</strong>
            <br />— Communicate with you over email according to your
            Notification preferences,
            <br /> — Contact you and maintain records in order to provide
            customer service and support,
            <br /> — Ensure there is no fraud with voting, polls and
            competitions we host,
            <br /> — When we use cookies to remember your preferences,
            <br /> — When we strive to detect and defend against fraudulent,
            abusive and unlawful activity on the site.
            <br />
            2.1.2. When the purpose is to <strong>measure</strong> and{" "}
            <strong>analyze traffic:</strong>
            <br />— We use Google Analytics, a web analytics service provided by
            Google, Inc., to collect information about how users use our site.
            We use the information to compile reports and to help us improve the
            site. The cookies collect information, including the number of
            visitors to the website, where visitors have come to the website
            from and the pages they visited. You can read more about these
            cookies and how Google safeguard them{" "}
            <a
              href="https://support.google.com/analytics/answer/6004245"
              rel="nofollow"
            >
              here
            </a>
            , — We use ScorecardResearch tags for market research purposes to
            count users who have visited and seen a page or various parts of a
            page to improve the experience on our site. You can find out more
            about ScorecardResearch, including how to opt-out right{" "}
            <a
              href="https://www.scorecardresearch.com/About.aspx?newlanguage=1"
              rel="nofollow"
            >
              here.
            </a>
            <br />
          </Text>
          <Text>
            2.2. Additionally, we ask your <strong>Consent</strong> to process
            the data we need:
            <br />
            2.2.1. When the purpose is{" "}
            <strong>better advertising experience.</strong> We would like the
            ads on our sites to be relevant and tailored to your interests,
            nobody likes seeing those hair grow vitamin ads, when you CLEARLY
            are not going bald (you're not, don't worry… I mean it).
            <br />— Cookies and similar technologies help us know what interests
            you might have,
            <br />— Location services help to only show you relevant ads,
            matching your location or language,
            <br />— Our partners may use the data they have about you, collected
            according to their own policies to show you what they believe would
            be relevant.
          </Text>
        </HomeAccordion>
        <HomeAccordion title={"3. How the information may be shared?"}>
          <Text>
            We strive to ensure, using technological and contractual mechanisms,
            that your data is protected and only used according to this policy.
            We need to share certain data with our trusted partners:
            <br />
            - When we manage newsletters, we use MailerLite to help us do it.
            You can always unsubscribe via unsubscribe function in the
            newsletter,
            <br />
            - When we optimise our site and innovate we may use partners who
            provide services and functionalities we need, such as Google and
            others,
            <br />
            – When we deliver ads via vendors and third-party vendors. This
            helps you get better ads. <br />– When we would need for Legal
            purposes and according to the law.
          </Text>
        </HomeAccordion>
        <HomeAccordion title={"4. How the data might be transferred?"}>
          <Text>
            The data we process about individuals in the EU/EEA may be
            transferred from the EU/EEA through various compliance mechanisms,
            including data processing agreements we have with our partners. By
            using our services you consent to us transferring your information
            to our partners outside of EU/EEA. Any organisation who has access
            to your information in the course of providing services on our
            behalf will be governed by contractual restrictions to make sure
            they protect your information and comply with applicable data
            protection legislation.
          </Text>
        </HomeAccordion>
        <HomeAccordion title={"5. How we protect privacy of children?"}>
          <Text>
            Our services are aimed at a general audience. We do not knowingly
            target, collect, use or share information that could reasonably be
            used to identify children under the age of 16 without prior parental
            consent or consistent with applicable law. By using our service you
            confirm that you either are of legal age or have an applicable
            consent.
          </Text>
        </HomeAccordion>
        <HomeAccordion
          title={"6. How can you exercise your rights under GDPR?"}
        >
          <Text>
            6.1. If you are an individual browsing from the EU/EEA, where the
            General Data Protection Regulations apply, you can exercise rights
            related to your data by contacting us via contact details at the
            bottom of the page:
            <br />— You can request <strong>access</strong> to a free copy of
            your data,
            <br />— You can ask us to <strong>delete</strong> your personal
            data, and we will do so where we legally can,
            <br />— You have a right to <strong>rectify</strong> your data,
            <br />— If you wish to <strong>object</strong> to us processing your
            data according to Legitimate interest.
            <br />— You have a right to <strong>complain</strong> about us with
            our supervisory authority{" "}
            <a href="https://vdai.lrv.lt/" rel="nofollow">
              here.
            </a>
          </Text>
          <Text>
            6.2. Your above described requests will be executed in a legally
            required time frame, 1 month, and we will need you to provide a
            valid proof of identification with each request.
          </Text>
        </HomeAccordion>
        <HomeAccordion title={"7. How long do we keep the data?"}>
          <Text>
            We store your data for no longer than necessary in relation to the
            purpose under which such data was collected. This is determined on a
            case by case basis and depends on things such as the nature of the
            data provided, why it was collected, the legal basis we rely upon to
            process the data, and our relevant legal or operation retention
            requirements. For example, if you request to delete your account we
            still have to retain some data for fraud prevention purposes and
            financial auditing.
          </Text>
        </HomeAccordion>
        <HomeAccordion title={"8. What about Cookies?"}>
          <Text>
            8.1. When you use our websites and apps we may collect information
            using cookies or similar technologies. Cookies are small files that
            are downloaded to your computer or mobile device when you visit a
            website. Your browser sends these cookies back to the website every
            time you visit the site again, so it can recognise you. This allows
            websites to tailor what you see on the screen.
            <br />
            We use cookies as they are a very important part of the internet,
            they help sites to work smoother, just like what a cup of morning
            coffee does to you. The cookies we use are for:
            <br />
            <strong>– Services</strong> – to make sure the site functions as
            expected, they are essential to you being able to enjoy the
            experience,
            <br />
            <strong>– Analytics</strong> – those are also super important, they
            allow us to understand how all users combined use our site, make
            business decisions based on it and do what we need to do on our side
            to make the site viable,
            <br />
            <strong>– Preferences</strong> – yeah, this is to remember your
            consent status, so we don’t bug you with a pop-up on each visit,
            <br />
            <strong>– Advertising</strong> – you might not think that, but this
            part is very important too, cookies help us provide you the best
            possible experience with ads, without them there would be a wild
            wild west of terrible banners everywhere. Also they help us pay our
            bills and provide you with great content, just keep that in mind. We
            use a Google tool called Google Double Click to make this all
            happen.
          </Text>
          <Text>
            8.2. If you use an Ad-blocker on our site, we cannot fully execute
            our services and therefore ensure your rights under this policy.
          </Text>
          <Text>
            8.3. You can manage your cookie settings by:
            <br />
            — changing your Privacy Settings,
            <br />
            — changing settings on your mobile device,
            <br />— changing your browser settings,
            <br />— opting out{" "}
            <a href="https://www.youronlinechoices.com/" rel="nofollow">
              here
            </a>
            .
          </Text>
          <Text>
            Please contact us if you need assistance with anything. We want you
            to be aware that by changing certain preferences you might cause the
            page to not work correctly, or at all, and that would be very sad,
            wouldn’t it? Changing the settings, also, would not remove
            advertising from the site, but would instead make it less relevant
            and even more annoying.
          </Text>
        </HomeAccordion>
        <HomeAccordion title={"9. Changes?"}>
          <Text>
            We may amend or update this Privacy Policy from time to time, so you
            should check it periodically. Where changes are made, we will post
            the revised Policy here with an updated effective date.
          </Text>
        </HomeAccordion>
        <HomeAccordion title={"10. How to contact us?"}>
          <Text>
            Backbone is in a closed beta at the moment and does not accept new
            applications. For any questions, contact{" "}
            <a href="mailto:analytics@boredpanda.com">
              analytics@boredpanda.com
            </a>
          </Text>
        </HomeAccordion>
      </HomeContainer>
    </Section>
  );
};

export default HomeFaq;
